import PropTypes from 'prop-types';
import { useMemo } from 'react';
import Select from 'react-select';
import { CustomStyle } from '../../../components/CustomSelectStyle';
import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import removeDuplicates from '../../../utils/removeDuplicates';
import { CharterTimeContainer } from './styles';

export default function CompanySelectionCard({
  setSelectedWorkplace,
  selectedWorkplace,
  workplaces,
  setEmployeeCharterTime,
  employeeCharterTime,
}) {
  const selectedWorkplaceCharterTimes = useMemo(() => {
    if (!selectedWorkplace?.charters) {
      return [];
    }

    const chartersByRoute = selectedWorkplace.charters.filter(
      (charter) => !!charter.horaChegada && !!charter.horaSaida,
    ).reduce((acc, charter) => {
      const routeBase = charter.routeID.slice(0, -1);
      if (!acc[routeBase]) {
        acc[routeBase] = {};
      }
      const direction = charter.routeID.slice(-1);
      if (direction === '1') {
        acc[routeBase].ida = charter;
      } else if (direction === '2') {
        acc[routeBase].volta = charter;
      }
      return acc;
    }, {});

    return removeDuplicates(Object.values(chartersByRoute).map((routePair) => {
      if (routePair.ida && routePair.volta) {
        return `${routePair.ida.horaChegada}-${routePair.volta.horaSaida}`;
      }
      return null;
    }).filter(Boolean));
  }, [selectedWorkplace]);

  return (
    <>
      <div className="title">
        Por fim, selecione abaixo seu local de trabalho.
      </div>
      <Select
        value={
                {
                  value: selectedWorkplace.value,
                  label: selectedWorkplace.label,
                }
              }
        options={workplaces}
        onChange={(opt) => {
          setSelectedWorkplace({
            value: opt.value,
            label: opt.label,
            address: opt.address,
            hasCharter: opt.hasCharter,
            charters: opt.charters,
            makesIntegration: opt.makesIntegration,
          });
          setEmployeeCharterTime('');
        }}
        styles={CustomStyle}
        classNamePrefix="react-select"
        className="react-select-container"
      />
      {selectedWorkplace.address && (
        <div className="small">
          {selectedWorkplace.address}
        </div>
      )}
      {((selectedWorkplaceCharterTimes.length > 0) && selectedWorkplace.hasCharter) && (
        <CharterTimeContainer>
          <strong>Selecione o seu horário de trabalho</strong>
          <FilterRadioButtonsContainer maxWidth="100%">
            {selectedWorkplaceCharterTimes.map((time) => (
              <FilterRadioButton
                key={time}
                onClick={() => setEmployeeCharterTime(time)}
                selected={employeeCharterTime === time}
              >
                {time}
              </FilterRadioButton>
            ))}
          </FilterRadioButtonsContainer>
        </CharterTimeContainer>
      )}
    </>
  );
}

CompanySelectionCard.propTypes = {
  setSelectedWorkplace: PropTypes.func.isRequired,
  selectedWorkplace: PropTypes.shape().isRequired,
  workplaces: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setEmployeeCharterTime: PropTypes.func.isRequired,
  employeeCharterTime: PropTypes.string.isRequired,
};
